import React from "react";
import { isEmpty } from "lodash";

import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { PreviewPersonalInformationBlock } from "@/components/PreviewPersonalInformationBlock";
import { PreviewLocationBlock } from "@/components/PreviewLocationBlock";
import { PreviewHeadingBlock } from "@/components/PreviewHeadingBlock";
import { Typography } from "@/components/Typography";
import { IconList } from "@/components/IconList";

import { PreviewEventDateBlock } from "./components/PreviewEventDateBlock";
import { useEventData } from "./hooks/useEventData";
import { QRProps } from "@/contexts/QREditorContext/types";
import { Icons } from "@/types/icons";

import "./EventTemplate.scss";

export const EventTemplate = (props: QRProps<"event">) => {
  const { data, isInitPreview, locale, t } = useEventData(props);

  if (!data) return null;

  const {
    eventDateTime,
    logoUrl,
    infoTitle,
    infoDescription,
    infoActionTitle,
    infoActionUrl,
    themeColor,
    facilities,
    addressData,
    organizerData,
    calendarEvent,
  } = data;

  return (
    <PhoneLayout
      page="event"
      dataQA="preview-event-container"
      backgroundColor={themeColor?.backgroundColor}
      hasIncludeBrowser
      isInitPreview={isInitPreview}
    >
      <div className="event-template">
        <PreviewHeadingBlock
          isInitPreview={isInitPreview}
          image={logoUrl}
          title={infoTitle}
          text={infoDescription}
          actionText={infoActionTitle}
          actionUrl={infoActionUrl}
          actionColor={themeColor?.buttonColor}
        />

        <div className="event-template__content qr-content">
          <PreviewEventDateBlock
            title={t("preview_time")}
            data={eventDateTime}
            labels={{
              start: t("preview_time_start"),
              end: t("preview_time_end"),
              schedule: t("preview_time_schedule"),
              allDay: t("preview_all_day"),
            }}
            calendarEvent={calendarEvent}
            themeColor={themeColor}
            locale={locale}
          />

          <PreviewLocationBlock
            title={t("preview_location")}
            data={addressData}
          />

          <PreviewPersonalInformationBlock
            title={t("preview_organizer")}
            iconName={Icons.users}
            data={organizerData}
          />

          {!isEmpty(facilities) && (
            <div className="event-template__facilities u-card">
              <Typography
                Tag="p"
                size="m"
                classname="event-template__facilities-title u-semibold"
              >
                {t("preview_facilities")}
              </Typography>
              <IconList
                compact
                items={facilities as unknown as string[]}
              />
            </div>
          )}
        </div>
      </div>
    </PhoneLayout>
  );
};

export default EventTemplate;
